import { TitleCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { RouterModule } from '@angular/router'

import { Store } from '@core/stores'
import { CoinsTagComponent } from '../coins-tag/coins-tag.component'

@Component({
  selector: 'user-info-card',
  imports: [RouterModule, TitleCasePipe, CoinsTagComponent],
  templateUrl: './user-info-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInfoCardComponent {
  store = inject(Store)
  user = computed(() => this.store.currentUser())
}
